import React from "react";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";
import { Loading as EbscoUILoading } from "@ebsco-ui/ebsco-ui";
import sharedMessages from "../../../shared-messages";

const Loading = ({ intl: { formatMessage } }) => {
  return (
    <EbscoUILoading loadingMessage={formatMessage(sharedMessages.loading)} />
  );
};

Loading.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired
  }).isRequired
};

export { Loading };
export default injectIntl(Loading);
